// Angular + external
import {
  ApplicationRef,
  Component,
  ElementRef,
  OnInit,
  OnDestroy,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { Subscription } from "rxjs";
// BFX
// cubiq
import * as CubiqTS from "shared/cubiq-model-multi-asset";
// services
import { BfxConfigService } from "../../shared/auth-services/system-config/bfx-config.service";
import { BfxDialogsCoordinatorService } from "./services/bfx-dialogs-coordinator.service";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Component({
  selector: "bfx-dialogs",
  templateUrl: "./html/bfx-dialogs-container.html",
  standalone: false,
})
export class BfxDialogsContainerComponent implements OnInit, OnDestroy {
  /***************************************/
  /* DATA */
  public config: any = {
    debug: false,
  };

  private configurationSubscription: Subscription;

  @ViewChild("dialog", { read: ViewContainerRef, static: true })
  viewContainerRef: ViewContainerRef;

  /**********************************************************************/
  /* CONSTRUCTOR */
  constructor(
    private _configService: BfxConfigService,
    private _dialogCoordinatorService: BfxDialogsCoordinatorService,
  ) {
    this.subscribeToConfiguration();
  }

  /**********************************************************************/
  /* INITIALIZATION - LIFE CYCLE HOOKS */
  ngOnInit() {
    this._dialogCoordinatorService.setRootViewContainerRef(this.viewContainerRef);
  }

  ngOnDestroy() {
    this.configurationSubscription.unsubscribe();
  }

  /**********************************************************************/
  /* INITIALIZATION - SUBSCRIPTIONS */
  private subscribeToConfiguration(): void {
    this.configurationSubscription = this._configService.uiConfig$.subscribe((config) => {
      this.config.debug = config.general.debug;
    });
  }
}
